import $ from 'jquery';
import 'select2';
import 'jquery.easing';
import 'Inputmask';
import 'jquery-validation';

const $calculators = $('.calculator');

$calculators.each((i, el) => {
  const $el = $(el);

  // Calculator functionality
  // ------------------------------------------------------------------------ //

  // Inputs
  const $rateForm = $el.find('.calculator-converter-form');
  const $currencyValueFrom = $el.find('#currency-value-from');
  const $currencyKindFrom = $el.find('#currency-kind-from');
  const $currencyKindTo = $el.find('#currency-kind-to');
  const $currencyRateText = $el.find('#alert-rate');
  // Outputs
  const $outputValueFrom = $el.find('.calculator-output-value-from');
  const $outputKindFrom = $el.find('.calculator-output-kind-from');
  const $outputValueTo = $el.find('.calculator-output-value-to');
  const $outputKindTo = $el.find('.calculator-output-kind-to');
  const $outputSuccess = $el.find('.calculator-output-success');
  const $outputError = $el.find('.calculator-output-error');
  const $outputCalc = $el.find('.calculator-output');
  const $outputUnitRate = $el.find('.calculator-unit-rate');
  const $outputInvUnitRate = $el.find('.calculator-inv-unit-rate');
  // Actions
  const $rateCalculate = $el.find('.calculator-rate');
  const $currencySwap = $el.find('.calculator-converter-swap');
  // API URL build
  const calcAPI = $rateForm.data('api-root') + $rateForm.data('api-url');
  // Keep track if taking values from left to right with form inputs or the other way
  let isReversed = false;

  // Auto-format inputs to currency
  $currencyValueFrom.inputmask();

  // Enable select2
  $currencyKindFrom.select2({
    templateResult: templateResultCurrency,
    templateSelection: templateSelectionCurrency
  });

  $currencyKindTo.select2({
    templateResult: templateResultCurrency,
    templateSelection: templateSelectionCurrency
  });

  function templateSelectionCurrency(country, notList) {
    notList = notList ? true : false;
    if (!country.id) {
      return country.text;
    }
    var countryCode = country.element.value.toLowerCase();
    var countrySym = country.id;
    var countryName = country.text.slice(country.text.lastIndexOf('-') + 1).trim();
    var $country = $(
      '<span class="currency-select"><i class="flag-icon flag-icon-' + countryCode.slice(0, 2) + '" /></i><span class="curr-opt-items"><span class="curr-sym">' + countrySym + (notList ? '' : ' -&nbsp;') + '</span><span>' + countryName + '</span></span></span>'
    );
    return $country;
  }

  function templateResultCurrency(country) {
    return templateSelectionCurrency(country, false);
  }

  function updateRateUI(data) {
    if (isReversed) {
      // Update Select Values
      $currencyKindFrom.val(data.FromCurrency);
      $currencyKindTo.val(data.ToCurrency);
      // Update view via select2
      $currencyKindFrom.select2({
        templateResult: templateResultCurrency,
        templateSelection: templateSelectionCurrency
      });
      $currencyKindTo.select2({
        templateResult: templateResultCurrency,
        templateSelection: templateSelectionCurrency
      });
    }
    // Left output
    $outputValueFrom.html(data.ResultFrom);
    $outputKindFrom.html($('#currency-kind-from option:selected').text());
    // Right output
    $outputValueTo.html(data.ResultTo);
    $outputKindTo.html($('#currency-kind-to option:selected').text());
    // Alert
    $alertRate.attr('placeholder', $currencyRateText.data('text-alert') + ' ' + data.FromCurrency + ' > _ ' + data.ToCurrency);
    // Rate
    $outputUnitRate.html(data.ResultUnitConversion);
    $outputInvUnitRate.html(data.ResultUnitConversionReverse);
  }

  function showRateError() {
    $outputSuccess.hide();
    $outputError.show();
  }

  function clearRateError() {
    $outputSuccess.show();
    $outputError.hide();
  }

  function getRate() {
    const val = $currencyValueFrom.val();
    const from = isReversed ? $currencyKindTo.val() : $currencyKindFrom.val();
    const to = isReversed ? $currencyKindFrom.val() : $currencyKindTo.val();
    // call GTM
    var eobj = { amount: val, from: from, to: to };
    callGTM('getRate', eobj);

    // call API
    $.ajax({
      method: 'GET',
      url: `${calcAPI}${val}/${from}/${to}/`
    })
      .done(data => {
        clearRateError();
        updateRateUI(data);
      })
      .fail(() => {
        showRateError();
      });
  }

  // Bind
  // ----------------------------------------- //
  $('#btn-calculate').on('click', e => {
    isReversed = false;
    getRate();
    $outputCalc.addClass('is-open');
    // WCAG
    $outputCalc.attr('aria-hidden', false);
    $('#btn-calculate').attr('aria-expanded', true);
  });
  // Swap
  $currencySwap.on('click', () => {
    isReversed = true;
    getRate();
  });

  // Set Rate Alert functionality
  // ------------------------------------------------------------------------ //
  const alertAPI = 'https://business.westernunion.com/api/converter/alert/';
  const $alertForm = $el.find('.calculator-alert-form');
  const $alertEmail = $alertForm.find('#alert-email');
  const $alertRate = $alertForm.find('#alert-rate');
  const $alertBtn = $alertForm.find('.calculator-alert-btn');
  const $alertMessage = $el.find('.calculator-alert-message');
  const $alertSuccess = $el.find('.calculator-alert-message-success');

  $alertRate.inputmask();

  function showAlertSuccess() {
    $alertMessage.addClass('show-success');
  }

  function showAlertError() {
    $alertMessage.addClass('show-error');
  }

  function resetAlertForm() {
    $alertEmail.val('');
    $alertRate.val('');
  }

  $alertForm.validate({
    errorClass: 'is-invalid',
    submitHandler: () => {
      const email = $alertEmail.val();
      const country = $currencyKindFrom.val().substring(0, 2);
      const targetRate = $alertRate.val();
      const fromCurrency = $currencyKindFrom.val();
      const toCurrency = $currencyKindTo.val();
      $alertMessage.removeClass('show-success').removeClass('show-error');
      $alertBtn.addClass('is-loading').attr('disabled', 'disabled');

      $.ajax({
        method: 'GET',
        url: `${alertAPI}${email}/${country}/${targetRate}/${fromCurrency}/${toCurrency}`
      })
        .done(() => {
          callGTM('rateAlertSuccess');
          showAlertSuccess();
          resetAlertForm();
          $alertBtn.removeClass('is-loading').removeAttr('disabled');
        })
        .fail(data => {
          console.log('error', data);
          showAlertError();
          $alertBtn.removeClass('is-loading').removeAttr('disabled');
        });

      return false;
    }
  });

  // Open close functionality
  // ------------------------------------------------------------------------ //
  const $ctaBtn = $el.find('.calculator-cta');
  const $alertSection = $el.find('.calculator-alert');
  let isOpen = false;

  function openAlert() {
    // Get height of alert section
    // (which is absolutely positioned off the left of the screen)
    const height = $alertSection.outerHeight();
    // Make height 0
    $alertSection.css('height', 0);
    // Bring alert onto the screen
    $el.addClass('is-open');
    // Animate the height of the alert section
    $alertSection.animate(
      {
        height
      },
      400,
      'easeOutQuad',
      () => {
        // clear out the inline styles so things work responsively
        $alertSection.attr('style', '');
      }
    );
    // Set things as open
    isOpen = true;
  }

  function closeAlert() {
    // Animate the height of the alert section
    $alertSection.animate(
      {
        height: 0
      },
      400,
      'easeOutQuad',
      () => {
        // Hide alert on screen
        $el.removeClass('is-open');
        // clear out the inline styles so things work responsively
        $alertSection.attr('style', '');
      }
    );
    // Set things as closed
    isOpen = false;
  }

  $ctaBtn.click(e => {
    e.preventDefault();
    if (isOpen) {
      closeAlert();
    } else {
      openAlert();
    }
  });
});

// Send data to Google Tag Manager via event
function callGTM(ename, eobj) {
  var gtmstr = 'window.dataLayer = window.dataLayer || [];';
  gtmstr += 'window.dataLayer.push({';
  if (typeof eobj != "undefined") {
    gtmstr += "'event': '" + ename + "',";
    if (Object.keys(eobj).length > 0 && eobj.constructor === Object) {
      var currPairCode = eobj.amount + "-" + eobj.from + "-to-" + eobj.to;
      gtmstr += "'currPairCode': '" + currPairCode + "',";
      gtmstr += "'currVal': '" + eobj.amount + "',";
      gtmstr += "'currFrom': '" + eobj.from + "',";
      gtmstr += "'currTo': '" + eobj.to + "',";
    }
  } else if (ename == "rateAlertSuccess") {
    gtmstr += "'event':'" + ename + "',";
  }
  gtmstr += '});'; //some arbitrary name for the page/state
  if (typeof gtmstr !== 'undefined' && gtmstr.length > 0)
    eval(gtmstr);
}
